<template>
  <div class="summary-item-background noselect">
    <div class="div-column"> 
      <span>{{ label }}</span>
      <span class="bl-color bold">{{ value }}</span>
    </div>
    <clipboard-button v-if="value" :value="value"/>
  </div>
</template>

<script>
import ClipboardButton from "./ClipboardButton";

export default {
  name: "TextValueHolder",
  components: {ClipboardButton},
  props: {
    label: String,
    value: [String, Number, null],
  },
}
</script>

<style lang="scss" scoped>
.summary-item-background {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
  position: relative;
  border: 1px solid var(--app-border);
  background: var(--app-surface-muted);
  color: var(--app-text);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 10px;
}

.div-column{
  width: 100%;
  display: flex;
  flex-direction: column;
}

</style>
